import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
	label: string;
	subtitle?: string;
	onClick: () => void;
	icon?: ReactNode;
	element?: ReactNode;
	truncate?: boolean;
};

export const DetailActionRow: FC<Props> = ({
	label,
	subtitle,
	onClick,
	icon,
	element,
	truncate = false,
}) => {
	const theme = useTheme();

	return (
		<Stack
			component={ButtonBase}
			direction="row"
			alignItems="center"
			onClick={onClick}
			width="100%"
			textAlign="left"
			sx={{
				borderBottom: theme.colors.border.solid(theme.palette.divider),
				"&:last-of-type": { borderBottom: "none" },
				"&:active": { bgcolor: theme.palette.grey[50] },
			}}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			gap={theme.spacingTokens.md}
		>
			{icon}
			<Stack flexGrow={1} minWidth={0}>
				<Typography
					variant="bodyMedium"
					sx={{
						...(truncate
							? {
									whiteSpace: "nowrap",
									overflow: "hidden",
									textOverflow: "ellipsis",
								}
							: { whiteSpace: "normal", overflowWrap: "break-word" }),
					}}
				>
					{label}
				</Typography>
				{subtitle && (
					<Typography variant="caption" color={theme.palette.grey[500]} noWrap>
						{subtitle}
					</Typography>
				)}
			</Stack>
			{element && (
				<Stack flexShrink={0} whiteSpace="nowrap">
					{element}
				</Stack>
			)}
			<ChevronRight
				size={theme.iconSize.sm}
				color={theme.palette.grey[400]}
				style={{ flexShrink: 0 }}
			/>
		</Stack>
	);
};
